import styled from 'styled-components'

import { _L_Normal, _S_Normal, ellipsis, mainColors } from '@avantstay/backoffice-core'

export const UserDetail = styled.div`
  display: grid;
  grid-template-columns: 35px repeat(2, 1fr);
  gap: 10px;
  flex: 1;

  &:hover {
    text-decoration: none;
  }
`

export const UserDetailColumn = styled.span`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  overflow: auto;
`

export const DetailTitle = styled.h3`
  ${_L_Normal}
  color: ${mainColors.black};
  ${ellipsis};
`

export const DetailSubtitle = styled.h5`
  ${_S_Normal}
  color: ${mainColors.neutralExtremelyDark};
  ${ellipsis};
`
